import { createFileRoute, Outlet, redirect, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/api/endpoints';
import { tokenStore } from '@/lib/auth';
import { AdminShell } from '@/components/admin/admin-shell';

/**
 * Layout do /admin.
 * - Bloqueia não autenticados (beforeLoad).
 * - Bloqueia não-admin com tela amigável dentro do shell.
 *   (Não usa redirect porque o role só é conhecido após /v1/auth/me.)
 */
export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    if (!tokenStore.getAccess()) throw redirect({ to: '/login' });
  },
  component: AdminLayout,
});

function AdminLayout() {
  const { data: me, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: authApi.me,
    enabled: !!tokenStore.getAccess(),
  });

  if (isLoading) {
    return (
      <AdminShell>
        <div className="text-sm text-slate-400">Carregando...</div>
      </AdminShell>
    );
  }

  if (me && me.role !== 'ADMIN') {
    return (
      <AdminShell>
        <div className="bg-white rounded-xl border border-slate-200 p-12 text-center max-w-lg">
          <h2 className="font-bold text-slate-700">Acesso restrito</h2>
          <p className="text-slate-500 mt-2 text-sm">Esta área é exclusiva para administradores.</p>
          <Link to="/dashboard" className="mt-4 inline-block text-teal-600 hover:underline text-sm">
            ← Voltar ao painel
          </Link>
        </div>
      </AdminShell>
    );
  }

  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}
